import { faReceipt, faHouseWindow, faInboxFull, faCalendarDays } from "@fortawesome/pro-solid-svg-icons"
import {
    USER_REPORTS_ARCHIVE_ROUTE,
    USER_REPORTS_CALENDAR_ROUTE,
    USER_REPORTS_ROUTE,
    USER_REPORTS_UPCOMING_ORDERS_ROUTE,
} from "../../../constants/routes"
import { NarrowNavItem } from "../../../shared/layouts/NarrowNavItems"
import { EnvironmentType } from "../../environment/envTypes"

export const userReportingNavItems: NarrowNavItem[] = [
    { icon: faHouseWindow, label: "Home", translationLabel: "user-nav-item-home-label", route: USER_REPORTS_ROUTE },
    {
        icon: faCalendarDays,
        label: "Calendar",
        translationLabel: "user-nav-item-calendar-label",
        route: USER_REPORTS_CALENDAR_ROUTE,
        environments: [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA],
    },
    {
        icon: faReceipt,
        label: "Upcoming orders",
        translationLabel: "user-nav-item-upcoming-orders-label",
        route: USER_REPORTS_UPCOMING_ORDERS_ROUTE,
        environments: [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA],
    },
    {
        icon: faInboxFull,
        label: "Archive",
        translationLabel: "user-nav-item-archive-label",
        route: USER_REPORTS_ARCHIVE_ROUTE,
        environments: [EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA],
    },
]
